import PhotoSwipeService from "./photoSwipe.service";
import ThumbnailService from "./thumbnail.service";

class ImageService {
    /**
     * 이미지 갤러리 열기
     *
     * @param {Object} params
     * @param {Array} params.files 이미지 목록
     * @param {Object} params.file 선택한 이미지
     * @param {Function} params.getUrl 이미지 URL 생성 함수
     */
    async openGallery({files, file, getUrl}) {
        const index = files.findIndex(item => item.name === file.name);
        const items = files.map(item => {
            const src = getUrl(item.name, false);
            return {
                src,
                name: item.name,
                thumb: src,
            };
        });

        ThumbnailService.setFiles(items);
        PhotoSwipeService.open(
            items,
            index,
            ThumbnailService
        );
    }
    
    closeGallery() {
        PhotoSwipeService.close();
    }

    nextImage() {
        PhotoSwipeService.next();
    }

    prevImage() {
        PhotoSwipeService.prev();
    }

    goToImage(index) {
        PhotoSwipeService.goTo(index);
    }

    getCurrentIndex() {
        return PhotoSwipeService.getCurrentIndex();
    }

    onChange(callback) {
        PhotoSwipeService.onChange(callback);
    }

    onClose(callback) {
        PhotoSwipeService.onClose(callback);
    }
}
export default new ImageService();